import { useEffect, useState } from "react";
import { useContract } from "./useContract";

export const useHistoryContract = (id: string) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getHistory } = useContract();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await getHistory(id);
      if (res.status >= 400) {
        throw new Error(`${res.status}`);
      }
      setData(res.data);
    } catch (error) {
      setError("Ошибка запроса истории");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, getHistory]);

  return { data, isLoading, error };
};
